import { Component, ViewChild } from '@angular/core';
import { HelpdeskService } from './helpdesk.service';
import { ReportListComponent } from './report-list/report-list.component';
import { ReportFormComponent } from './report-form/report-form.component';
import { NgIf, NgClass } from '@angular/common';

@Component({
    selector: 'app-helpdesk',
    templateUrl: './helpdesk.component.html',
    styleUrls: ['./helpdesk.component.css'],
    imports: [NgIf, ReportListComponent, NgClass, ReportFormComponent]
})
export class HelpdeskComponent {
  @ViewChild(ReportListComponent) reportList: ReportListComponent;

  selectedReport = null;
  reports = [];
  isLoading:boolean = false;

  constructor(
    private helpdeskService: HelpdeskService
  ) { }

  ngOnInit(): void {
    this.getBugReport();
  }

  getBugReport(){
    this.isLoading = true;
    this.helpdeskService.getReports().subscribe((reports) => {
      this.reports = reports;
      this.isLoading = false;
    });
  }

  getSelectedReport(event) {
    this.selectedReport = event
  }

  supportTypeConversion(type) {
    return type == '1' ? 'Bug Report' : type == '2' ? 'Support Ticket' : 'Feature';
  }

  newTicket(){
    this.selectedReport = null; 
    this.reportList.selectedId = null;
    this.getBugReport()
  }
}
